import { useEffect } from 'react';

import { useUserState } from '../user-state';
import type { UserSnapshot } from '../user-state-adapter';
import { setUserSnapshot } from './user-state-adapter.internal';

const EMPTY_SNAPSHOT: UserSnapshot = {
  getActiveUser: (): null => null,
  licenses: [],
  isLoaded: false,
  isOrganizationAdmin: false,
  isCompanyAdmin: false,
  getProjects: () => undefined,
  getCompanyUsers: () => undefined,
  hasValidDesignToolSeat: () => false,
  hasDesignToolAccessForCurrentProject: () => false,
  isActiveRoleProjectUser: () => false,
};

/**
 * Renders nothing. Pushes a read-only user snapshot into userStateAdapter so non-React
 * code can read current user without touching React. Must be mounted inside UserStateProvider.
 */
export function UserStateAdapterBridge() {
  const state = useUserState();

  useEffect(() => {
    const snap: UserSnapshot = {
      getActiveUser: () => state.user ?? null,
      licenses: state.licenses,
      isLoaded: state.isLoaded,
      isOrganizationAdmin: state.isOrganizationAdmin,
      isCompanyAdmin: state.isCompanyAdmin,
      getProjects: state.getProjects,
      getCompanyUsers: state.getCompanyUsers,
      hasValidDesignToolSeat: state.hasValidDesignToolSeat,
      hasDesignToolAccessForCurrentProject: state.hasDesignToolAccessForCurrentProject,
      isActiveRoleProjectUser: state.isActiveRoleProjectUser,
    };
    setUserSnapshot(snap);
  }, [state]);

  useEffect(() => {
    return () => setUserSnapshot(EMPTY_SNAPSHOT);
  }, []);

  return null;
}
